// extracted by mini-css-extract-plugin
export default {"noticeContent":"noticeContent-rQsAPv","noticeItems":"noticeItems-DJ8Pub","content":"content-PtML1J","imageCom":"imageCom-oRtmsD","footerBtn":"footerBtn-pkupXk"};